import React, { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useApprovedButtonMutation } from '../../services/evidencePay';
import { Navigate, useNavigate } from 'react-router-dom';
import { getStorage } from '../../utils/functions/localstorage';
import jwtDecode from 'jwt-decode';
import Swal from 'sweetalert2';
import checkAccessRights from '../../utils/functions/accessRight';
import { ROLES } from '../../utils/constants';

function ApprovedButton({ sendVelue, uploadRef, t }) {
  const { value: merchant, allMerchant } = useSelector(
    (state) => state.merchant,
  );
  const isAdminRole = checkAccessRights(ROLES.ADMIN_ROLE);
  const isSuperAdminRole = checkAccessRights(ROLES.SUPER_ADMIN_ROLE);
  // const sorgcode = isAdminRole ? merchant || '' : allMerchant || '';
  const navigate = useNavigate();
  const token = getStorage('token');
  const decoded = jwtDecode(token);
  const axios = require('axios');

  const onSubmit = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_admin}/upload/approve-evidence`,
        {
          sorgcode: sendVelue?.sorgcode,
          orderIdRef: sendVelue?.transaction_ref,
          status: 'Approved',
          approver: decoded?.NAME,
          upload_ref: uploadRef,
        },
      );

      Swal.fire({
        position: 'center',
        icon: 'success',
        title: t('app.approvedSuccessfully'),
        showConfirmButton: false,
        timer: 3000,
          didOpen: () => {
             document.querySelector('.swal2-container').style.zIndex = '99999';
          }
      });

      navigate('/pending');

      // ตั้งค่าข้อมูลลูกค้าให้กับ state หรือทำตามที่ต้องการ
    } catch (error) {
      console.error('Error:', error.response?.data || error.message);
    }
  };

  return (
    <div>
      <div className="flex justify-center mt-5">
        <Button
          variant="contained"
          sx={{ width: '400px', color: 'white' }}
          onClick={onSubmit}
        >
          {t('app.approve')}
        </Button>
      </div>
    </div>
  );
}

export default ApprovedButton;
